import { RenderHTML } from '@wix/cc-user-facing-common-components';
import { Notification } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { useRouter } from 'next/router';
import React, { FunctionComponent, useState } from 'react';

import { LOCALES } from '../../../constants';
import { DATA_HOOKS } from '../../../dataHooks';
import { PageType } from '../../../types';

type ChineseNotificationProps = {
  pageType: PageType;
};

export const ChineseNotification: FunctionComponent<ChineseNotificationProps> =
  ({ pageType }) => {
    const { t } = useTranslation();
    const { locale } = useRouter();

    const isHomepage = pageType === PageType.Homepage;
    const isArticle = pageType === PageType.Article;
    const shouldShow = locale === LOCALES.ZH_HANT && (isHomepage || isArticle);

    const [isDisplay, setIsDisplay] = useState(shouldShow);

    if (!shouldShow) {
      return null;
    }

    const notificationText = isHomepage
      ? t('notification.bar.homepage.ai-translated')
      : t('notification.bar.articlepage.ai-translated');

    return (
      <Notification
        dataHook={DATA_HOOKS.CHINESE_NOTIFICATION}
        show={isDisplay}
        theme="standard"
        onClose={() => setIsDisplay(false)}
      >
        <Notification.TextLabel ellipsis={false} textAlign="center">
          <RenderHTML html={notificationText} />
        </Notification.TextLabel>
        <Notification.CloseButton />
      </Notification>
    );
  };
